export const COLORS = new Map([
  [
    'var(--Wine-Light)',
    {
      color: 'var(--Wine-Light)',
      subColor: '#90496C'
    }
  ],
  [
    'var(--Pink-Dark)',
    {
      color: 'var(--Pink-Dark)',
      subColor: '#F36C88'
    }
  ],
  [
    'var(--Orange-Dark)',
    {
      color: 'var(--Orange-Dark)',
      subColor: '#FA855E'
    }
  ],
  [
    'var(--Wine-Dark)',
    {
      color: 'var(--Wine-Dark)',
      subColor: '#815065'
    }
  ],
  [
    'var(--Pink-Light)',
    {
      color: 'var(--Pink-Light)',
      subColor: '#F388A1'
    }
  ],
  [
    'var(--Crimson-Dark)',
    {
      color: 'var(--Crimson-Dark)',
      subColor: '#B34C70'
    }
  ]
])
